"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.default = (function (_a) {
    var minPriceForFreeShipping = _a.minPriceForFreeShipping, totalBundlePrice = _a.totalBundlePrice;
    var progressPercentage = totalBundlePrice / minPriceForFreeShipping;
    return (React.createElement("div", { className: 'bg-almost-white width-100', style: { height: '10px', border: '1px solid #a05eb5', borderRadius: '5px' } },
        React.createElement("div", { className: 'bg-wisteria text-white flex-container align-middle', style: {
                height: '8px',
                transform: "scaleX(".concat(progressPercentage >= 1 ? 1 : progressPercentage, ")"),
                transformOrigin: 'left',
                transition: 'transform 0.25s ease-out',
                borderRadius: '5px',
            } }, "\u00A0")));
});
